exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-f13cce32]{height:25px;display:inline-block;margin:5px}.head-wrap[data-v-f13cce32]{background-color:#bf5700}.list__tile__title[data-v-f13cce32]{font-size:15px}.btn[data-v-f13cce32],.list__tile__title[data-v-f13cce32]{font-family:open_sans,sans-serif;font-weight:400;text-decoration-style:solid;text-transform:none}.btn[data-v-f13cce32]{border-radius:0;font-size:17.5px}.btn[data-v-f13cce32]:hover{background-color:#a04400!important;color:#fff}.drawer-single-line[data-v-f13cce32]:hover{color:#fff}.navbar[data-v-f13cce32]{border-bottom:1px solid #e1ddd2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f13cce32","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navigation.vue
// module id = 165
// module chunks = 0